/**
 * TextareaCounter
 * ======================================
 * - limit characters in textarea
 * - define limit via native attr [maxlength="500"]
 * - remaing element - search in parent of textarea
 */


const ELEMENTS = '.js-TextareaCounter'
const REMAINING_EL = '.app-field__maxlength-value'

class TextareaCounter {
  constructor() {
    this.elements = document.querySelectorAll(ELEMENTS)

    this.elements.forEach((el) => {
      el.addEventListener("input", event => {
        const target = event.currentTarget;
        const valueElement = target.parentNode.querySelector(REMAINING_EL)
        const maxLength = target.getAttribute("maxlength");
        const currentLength = target.value.length;

        if(valueElement) {
          if (currentLength >= maxLength) {
            valueElement.parentNode.classList.add('is-max')
          } else {
            valueElement.parentNode.classList.remove('is-max')
          }

          valueElement.innerHTML = maxLength - currentLength
        }
    });

    })
  }
}

new TextareaCounter()
